import { observer } from "mobx-react-lite";
import React from "react";
import { useAuth } from "react-oidc-context";
import logo from "../../assets/lm-logo-blue.svg";
import ErrorBoxMessage from "../../components/ErrorBoxMessage";
import { userStore } from "../../stores";
import "./style.scss";

const Unauthorized = observer(() => {
  const auth = useAuth();
  const onLogoutButtonClick = (e) => {
    e.preventDefault();
    auth.removeUser();
  };
  const access = userStore.getAccess;
  const isFetchingPermissions = !access.roles && !access.permissions;
  return isFetchingPermissions ? (
    <div>Fetching permissions...</div>
  ) : (
    <div className="logout-page">
      <div className="logout-interface">
        <img className="logout-logo" src={logo} alt="logout" />
        <div className="logout-title">Locate & Mark</div>
        <div className="logout-version">
          Build: {process.env.REACT_APP_VERSION.substring(0, 7) || "N/A"}
        </div>
        <ErrorBoxMessage errorToRender={"UNAUTHORIZED_APPLICATION"} />
        <button
          className="logout-button"
          type="button"
          onClick={(e) => onLogoutButtonClick(e)}
        >
          Log Out
        </button>
      </div>
    </div>
  );
});

export default Unauthorized;
